import React, { useState } from 'react'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Button, InputAdornment, Menu, MenuItem, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search'
import { userServices } from 'src/services/auth/user/user.service';
import { useGetIdentity } from 'react-admin';

export const TimezoneSelector = () => {
    const currentTimezone = localStorage.getItem('timezone')
    const [anchorEl, setAnchorEl] = useState(null)
    const timezones = Intl.supportedValuesOf('timeZone')
    const [filteredOptions, setFilteredOptions] = useState(timezones)
    const { identity } = useGetIdentity()

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setFilteredOptions(timezones)
        setAnchorEl(null)
    }

    const updateTimezone = async (timezone) => {
        try {
          await userServices.changeTimezone(identity?.user_id, { timezone: timezone })
        } catch (error) {
          console.log('updateTimezone error', error)
        }
      }

    const handleChange = (timezone) => {
        handleClose()
        localStorage.setItem('timezone', timezone)
        updateTimezone(timezone)
    }

    const onFilterOptions = (value) =>{
      const newValue = value.target?.value
      setTimeout(() => {
        if(newValue){
          setFilteredOptions(timezones.filter(timezone=>timezone.toLocaleLowerCase()?.includes(newValue)))
        } else {
          setFilteredOptions(timezones)
        }
      }, 1000);
    }
  return (
    <>
      <Button
        onClick={handleClick}
        startIcon={<AccessTimeIcon />}
        style={{
          textTransform: 'none',
          justifyContent: 'flex-start',
          width: '100%',
          paddingLeft: '22px',
        }}
      >
        {currentTimezone}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <TextField
          size='small'
          style={{margin:'10px', width:'90%'}}
          onChange={onFilterOptions}
          onKeyDown={(e) => {
            e.stopPropagation();
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        {filteredOptions.map(time=>(
            <MenuItem key={time} onClick={() => {handleChange(time)}}>
                <Typography variant='inherit'>{time}</Typography>
            </MenuItem>
        ))}
      </Menu>
    </>
  )
}
